import React from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/new-search-widget.module.scss";
import {COMPONENT_STATES} from "../../../core/consts";
import {LoadingIndicator} from "../../../core/components/loading/loading-indicator";

export const NewSearchWidgetLoader = observer(({controller}) => {
  const {state} = controller;
  const {componentState, hasQuery} = state;

  const isLoading: Boolean = componentState === COMPONENT_STATES.loading && hasQuery;

  return isLoading ? <div className={classNames(styles.loader)}>
    <LoadingIndicator width={24} height={24}/>
  </div> : null
});
